import React from 'react'
import ErrorBoundary from '@dustin-web/microsite-components/src/utils/error-boundary'

import {
  RenderExternalScript,
  RenderExternalStyle,
  RenderInlineStyle,
  RenderInlineScript,
} from '../../macros'
import { attributesToProps } from 'html-react-parser'
import type { Parser } from '.'

const BasicMacros = {
  RenderExternalScript,
  RenderInlineScript,
  RenderInlineStyle,
  RenderExternalStyle,
}

export const macroParser: Parser = (node, additionalMacros = {}) => {
  const availableMacros = { ...BasicMacros, ...additionalMacros }
  type AvailableMacroNames = keyof typeof availableMacros

  if (
    node.type === 'tag' &&
    node.name === 'embed' &&
    // eslint-disable-next-line no-prototype-builtins
    (node.attribs?.hasOwnProperty('macroalias') || node.attribs?.hasOwnProperty('macro'))
  ) {
    const macroName = (node.attribs.macroalias || node.attribs.macro) as AvailableMacroNames

    const props = attributesToProps(node.attribs) // Lowercased here..

    // eslint-disable-next-line no-prototype-builtins
    if (!availableMacros.hasOwnProperty(macroName)) {
      return <div>Unrecognized macro: {macroName}</div>
    }

    const Macro = availableMacros[macroName]
    return (
      <ErrorBoundary>
        <Macro {...(props as any)} />
      </ErrorBoundary>
    )
  }
}
